import { useTranslation } from "react-i18next";
import { List, Radio, Stack, Text } from "@mantine/core";
import { RadioSurvey } from "../../../components";

type Props = {
  form: any;
};

const Component = ({ form }: Props) => {
  const { t } = useTranslation();

  const manifestacionesAcosoLaboral = {
    AT_001AL:
      "Comentarios o bromas sobre características personales (raza, estatus social, apariencia física, forma de hablar).",
    AT_002AL:
      "Creación o difusión de rumores sobre la vida privada de una persona.",
    AT_003AL:
      "Comportamientos o mensajes amenazantes hacia una persona (verbal, escrito, digital).",
    AT_004AL:
      "Comportamientos que aíslan a una persona, como ignorar su presencia, no hablarle o impedirle hacerlo.",
    AT_005AL:
      "Críticas constantes al desempeño profesional o amenazas de medidas disciplinarias efectuadas de forma hostil.",
    AT_006AL:
      "Modificar condiciones laborales (horario, lugar, funciones, permisos) de forma injustificada, recurrente o diferenciada respecto al resto del personal.",
    AT_007AL:
      "No asignar trabajo a una persona o darle tareas inútiles, absurdas o con exigencias desproporcionadas.",
  };

  // Get selected manifestations from form
  const selectedManifestations = form.values.AT_001_007AL || [];
  // Filter manifestations that are selected and not "N.A"
  const displayedManifestations = selectedManifestations
    .filter(
      (key: string) =>
        key !== "N.A" &&
        manifestacionesAcosoLaboral[
          key as keyof typeof manifestacionesAcosoLaboral
        ]
    )
    .map(
      (key: string) =>
        manifestacionesAcosoLaboral[
          key as keyof typeof manifestacionesAcosoLaboral
        ]
    );

  return (
    <Stack spacing="md">
      {displayedManifestations.length > 0 && (
        <Stack spacing="xs">
          <Text size="sm" fw={500} color="gray.7">
            Sobre las siguientes situaciones:
          </Text>
          <List size="sm" spacing={4} withPadding>
            {displayedManifestations.map(
              (manifestacion: string, index: number) => (
                <List.Item key={index}>
                  <Text size="sm" color="gray.8">
                    {manifestacion}
                  </Text>
                </List.Item>
              )
            )}
          </List>
        </Stack>
      )}

      <RadioSurvey
        label={t("frequency.label")}
        {...form.getInputProps("FRE_001AL")}
      >
        <Radio
          label="Se trata de un evento puntual"
          value="Se trata de un evento puntual"
        />
        <Radio
          label="Varias veces a la semana"
          value="Varias veces a la semana"
        />
        <Radio label="Una vez al mes o menos" value="Una vez al mes o menos" />
        <Radio label="Varias veces al mes" value="Varias veces al mes" />
      </RadioSurvey>
    </Stack>
  );
};

export default Component;
